module.exports = __webpack_public_path__ + "img/ps.ce7d8b0.svg";